import { useMemo } from "react";
import { useParams } from "react-router";
import { useAppContext, resolveViewComponent } from "@data-root/react";

export const NestedScreen = () => {
  const { nestedId } = useParams();

  const { getView } = useAppContext();

  const view = useMemo(() => getView(nestedId), [getView, nestedId]);

  const Component = useMemo(() => resolveViewComponent(view.type), [view]);

  return <Component view={view} />;
};
